<template>
    <div class="marketing">
        <Header headTitle="마케팅 동의" isShowBackBtn @clickBack="cancel" />

        <div class="detail-page">
            <Marketing />
        </div>
    </div>
</template>

<script>
import Marketing from "@/_bayer/commonComp/policy/Marketing.vue";
import Header from "@/_bayer/commonComp/Header.vue";
export default {
    components: {
        Marketing,
        Header
    },
    methods: {
        cancel() {

        }
    }
}
</script>

<style lang="scss">
.marketing {
    .detail-page {
        .agree-content {
            width: 90vw;
            margin: 0 auto;
        }
    }
}
</style>